import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
    View,
    Image,
    StyleSheet
} from 'react-native';
import {
    JDText,
    JDImage,
    JDTouchable
} from '@jdreact/jdreact-core-lib';
import { NavBar, utils } from '@ltfe/ltfe-core-lib';
import img from '../common/img';

const { pt } = utils;

export default class Error extends PureComponent {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        codeInfo: {
            qrCodeUrl: img.error_icon
        }
    }

    render() {
        const { fromType } = this.props;

        return (
            <View>
                <NavBar title={ '评价详情' } />

                <View style={ { backgroundColor: '#fff', flexDirection: 'row', paddingBottom: pt(10) } }>

                    <View style={ { width: pt(107), flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } }>
                        <JDText style={ { color: 'rgb(255,85,51)', fontSize: pt(40), fontWeight: 'bold' } }>4.9</JDText>
                        <JDText style={ { color: 'rgb(100,100,110)', fontSize: pt(12) } }>综合评价</JDText>
                    </View>

                    <View style={ { flex: 1, flexDirection: 'row', flexWrap: 'wrap' } }>
                        <View style={ { backgroundColor: 'rgba(240,37,15,0.05)', width: pt(70), height: pt(26), borderRadius: pt(20), borderColor: 'rgba(240,37,15,1)', borderStyle: 'dashed', borderWidth: pt(1), justifyContent: 'center', alignItems: 'center', marginRight: pt(10), marginTop: pt(10) } }>
                            <JDText style={ { color: 'rgba(240,37,15,1)', fontSize: pt(12), alignItems: 'center', justifyContent: 'center' } }>全部(232)</JDText>
                        </View>
                        <View style={ { backgroundColor: 'rgba(240,37,15,0.05)', width: pt(70), height: pt(26), borderRadius: pt(20), justifyContent: 'center', alignItems: 'center', marginRight: pt(10), marginTop: pt(10) } }>
                            <JDText style={ { color: 'rgba(100,100,110,1)', fontSize: pt(12), alignItems: 'center', justifyContent: 'center' } }>好评(99)</JDText>
                        </View>
                        <View style={ { backgroundColor: 'rgba(240,37,15,0.05)', width: pt(70), height: pt(26), borderRadius: pt(20), justifyContent: 'center', alignItems: 'center', marginRight: pt(10), marginTop: pt(10) } }>
                            <JDText style={ { color: 'rgba(100,100,110,1)', fontSize: pt(12), alignItems: 'center', justifyContent: 'center' } }>晒图(151)</JDText>
                        </View>
                        <View style={ { backgroundColor: 'rgba(240,37,15,0.05)', width: pt(70), height: pt(26), borderRadius: pt(20), justifyContent: 'center', alignItems: 'center', marginRight: pt(10), marginTop: pt(10) } }>
                            <JDText style={ { color: 'rgba(100,100,110,1)', fontSize: pt(12), alignItems: 'center', justifyContent: 'center' } }>中评(432)</JDText>
                        </View>
                        <View style={ { backgroundColor: 'rgba(240,37,15,0.05)', width: pt(70), height: pt(26), borderRadius: pt(20), justifyContent: 'center', alignItems: 'center', marginRight: pt(10), marginTop: pt(10) } }>
                            <JDText style={ { color: 'rgba(100,100,110,1)', fontSize: pt(12), alignItems: 'center', justifyContent: 'center' } }>待改善(11)</JDText>
                        </View>
                    </View>
                </View>

            </View>
        );
    }
}
Error.contextTypes = {
    router: PropTypes.object
};
const st = StyleSheet.create({
    QRcode: {
        marginTop: pt(100),
        alignItems: 'center'
    },
    yzm: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: pt(207),
        height: pt(312)
    },
    txt_m: {
        textAlign: 'center',
        fontSize: pt(13),
        color: '#FF282828',
        fontWeight: 'normal'
    },
    txt_y: {
        fontSize: pt(16),
        color: 'gray',
        fontWeight: 'normal'
    },
    img_view: {
        paddingBottom: pt(23)
    },
    y_img: {
        height: pt(150),
        width: pt(150)
    },
    btn: {
        alignItems: 'center',
        justifyContent: 'center',
        width: pt(120),
        height: pt(35),
        borderRadius: pt(20),
        borderColor: 'red',
        marginTop: pt(20),
        backgroundColor: '#F5F7F8'

    }
});
